import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function FooterSection() {
  const whatsappLink = 'https://wa.me/905395851199?text=' + encodeURIComponent(
    'Merhaba, İlkim Butik Otel hakkında bilgi almak istiyorum. Fiyat ve müsaitlik bilgisi alabilir miyim?'
  );

  const { ref: footerRef, isVisible: footerVisible } = useScrollReveal({ threshold: 0.1 });

  return (
    <footer ref={footerRef} className="w-full py-12 md:py-16 px-4 md:px-8 lg:px-12 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className={`bg-secondary-50 rounded-3xl p-6 md:p-10 lg:p-12 border border-background-200/60 transition-all duration-700 ${footerVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            {/* Brand */}
            <div className="lg:col-span-1">
              <img
                src="https://static.readdy.ai/image/63ce3e67fd2d5effcfb662b2683f46ed/914cdb8302f01f3f895c80f38cdb1f03.jpeg"
                alt="İlkim Butik Otel"
                className="h-12 md:h-14 w-auto object-contain mb-4"
              />
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                Denize 70 metre mesafede, Kız Kumu Plajı'na yürüme mesafesinde, doğa içinde huzurlu butik otel tatili.
              </p>
              <div className="flex items-center gap-3">
                <a
                  href="https://www.instagram.com/ilkimbutikotel"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-50 text-primary-500 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer"
                >
                  <i className="ri-instagram-line text-base" />
                </a>
                <a
                  href={whatsappLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-green-50 text-green-600 hover:bg-green-600 hover:text-white transition-colors cursor-pointer"
                >
                  <i className="ri-whatsapp-line text-base" />
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="text-sm font-bold text-foreground-900 uppercase tracking-wider mb-4">
                Hızlı Bağlantılar
              </h4>
              <ul className="space-y-2.5">
                {[
                  { label: 'Ana Sayfa', href: '#hero' },
                  { label: 'Odalar', href: '#odalar' },
                  { label: 'Kahvaltı', href: '#kahvalti' },
                  { label: 'Havuz', href: '#havuz' },
                  { label: 'Konum', href: '#konum' },
                  { label: 'Fiyat Al', href: '#fiyat-form' },
                ].map((link) => (
                  <li key={link.href}>
                    <a
                      href={link.href}
                      onClick={(e) => {
                        e.preventDefault();
                        document.querySelector(link.href)?.scrollIntoView({ behavior: 'smooth' });
                      }}
                      className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact */}
            <div>
              <h4 className="text-sm font-bold text-foreground-900 uppercase tracking-wider mb-4">
                İletişim
              </h4>
              <ul className="space-y-3">
                <li className="flex items-start gap-2.5">
                  <i className="ri-map-pin-line text-primary-500 mt-0.5" />
                  <span className="text-sm text-foreground-600">
                    Marmaris / Orhaniye / Kız Kumu
                  </span>
                </li>
                <li>
                  <a
                    href="tel:+905395851199"
                    className="flex items-center gap-2.5 text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                  >
                    <i className="ri-phone-line text-primary-500" />
                    0539 585 11 99
                  </a>
                </li>
                <li>
                  <a
                    href={whatsappLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-2.5 text-sm text-foreground-600 hover:text-green-600 transition-colors cursor-pointer"
                  >
                    <i className="ri-whatsapp-line text-green-500" />
                    WhatsApp
                  </a>
                </li>
              </ul>
            </div>

            {/* CTA */}
            <div>
              <h4 className="text-sm font-bold text-foreground-900 uppercase tracking-wider mb-4">
                Rezervasyon
              </h4>
              <p className="text-sm text-foreground-600 mb-4">
                Size en uygun fiyat ve müsaitlik bilgisi için hemen WhatsApp'tan ulaşın.
              </p>
              <a
                href={whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-5 py-3 bg-primary-500 text-background-50 rounded-xl font-semibold text-sm hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer hover:scale-[1.02] active:scale-[0.98]"
              >
                <i className="ri-whatsapp-line" />
                WhatsApp'tan Rezervasyon Sor
              </a>
            </div>
          </div>

          {/* Bottom bar */}
          <div className="mt-8 pt-6 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-500">
              &copy; 2026 İlkim Butik Otel. Tüm hakları saklıdır.
            </p>
            <p className="text-xs text-foreground-500">
              Marmaris / Orhaniye / Kız Kumu
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}